<template>
  <div class="relative img-max" style="padding-bottom: 0.7rem;">
    <img v-if="shopType == '3'" src="./images/3.jpg" />
    <img v-else-if="shopType == '1' || shopType == '2'" src="./images/1-2.jpg" />
    <img v-else src="./images/5.jpg" />
    <div class="btn-wrap flex justify-center f14 white">
      <div class="radius50 btn flex items-center justify-center" @click="routerClick">申请合作</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .btn-wrap {
    left: 0;
    right: 0;
    position: fixed;
    background-color: #fff;
    bottom: 0;
    padding: 0.25rem 0;
  }

  .btn {
    width: 300px;
    height: 36px;
    background: linear-gradient(to right, #e34e46, #e96a40);
  }
</style>
<script>
  export default {
    data() {
      return {
        shopType: "" // 默认养殖会员，1、2运营中心和农信小站，3品牌企业
      };
    },
    created() {
      const { shopType } = this.$route.query;
      let title = "养殖会员";
      switch (shopType) {
        case "1":
          title = "运营中心";
          break;
        case "2":
          title = "农信小站";
          break;
        case "3":
          title = "品牌企业";
          break;
      }
      document.title = title;
      this.shopType = shopType || "";
    },
    methods: {
      routerClick() {
        let url = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2203081609050000115";
        if (this.shopType == "2") {
          url = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2109092011420000117";
        } else if (this.shopType == "1") {
          url = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2109092011420000117";
        } else if (this.shopType == "3") {
          url = "https://zntm.nxin.com/h5/intelligent/detail?NumericalOrder=2203081609320000115";
        }
        window.location.href = url;
      }
    }
  };
</script>